import { getContenType, sanitizedUrlFiles } from '../hooks/useFileViewer';

const extensionImages = {
  png: 'png',
  jpg: 'jpg',
  jpeg: 'jpeg'
};

export const FILE_DOWNLOAD_TYPES = {
  ZIP: 1,
  INDIVIDUAL: 2,
  COMBINE_PDF: 3,
  BROWSER: 4
};

export const extensionCanOpenInBrowser = [
  'pdf',
  extensionImages.jpg,
  extensionImages.jpeg,
  extensionImages.png
];

export const downloadBase64 = (file, fileName, ext) => {
  let type = 'application/pdf';

  // If you need another extension, search MIME Type Extension to find the correct one
  if (ext === 'xlsx') {
    type = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
  }
  const data = `data:${type};base64,${file}`;
  const link = document.createElement('a');

  link.href = data;
  link.download = `${fileName}.${ext || 'pdf'}`;
  link.click();
};

// If only one file will be downloaded, by passing the file name,
// it will not be downloaded as .zip
const downloadFiles = (blobData, oneFile, downloadType) => {
  const canVisualize =
    !oneFile || downloadType === FILE_DOWNLOAD_TYPES.BROWSER
      ? extensionCanOpenInBrowser.some((ext) => oneFile?.toLowerCase()?.includes(ext.toLowerCase()))
      : false;
  const type = canVisualize ? getContenType(oneFile?.toLowerCase()) : null;

  const url = window.URL.createObjectURL(new Blob([blobData], type));

  const sanityOptions = {
    allowScriptOrDataURI: false,
    allowCommsAppURI: false,
    allowDBConnectionStringURI: false,
    allowBrowserSpecificURI: false,
    allowWebTransportURI: false,
    allowServiceAPIURI: false,
    allowFileSystemURI: true
  };

  if (type) {
    sanitizedUrlFiles(url, sanityOptions);
  } else {
    const link = document.createElement('a');

    link.href = url;
    link.setAttribute(
      'download',
      FILE_DOWNLOAD_TYPES.ZIP === downloadType ? 'download.zip' : oneFile
    );
    document.body.appendChild(link);
    link.click(); // For other file types, just trigger the download
  }
};

export default downloadFiles;
